var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.306,
    height: 29.528,
    viewBox: "0 0 32.306 29.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_122210",
    x: 19.752,
    y: 14.371,
    width: 10.072,
    height: 5.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5142fc",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_122211",
    x: 0,
    y: 6.985,
    width: 29.824,
    height: 20.553,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_122212",
    x: 13.723,
    y: 10.945,
    width: 18.583,
    height: 18.583,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_122212-2",
    x: 13.723,
    y: 10.945,
    width: 18.583,
    height: 18.583,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.502,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_122213",
    x: 12.959,
    y: 0.001,
    width: 11.82,
    height: 5.912,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_122214",
    x: 5.462,
    y: 0,
    width: 8.945,
    height: 5.911,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122210-2",
    "data-name": "Path 122210",
    d: "M41.21,36.26a2.865,2.865,0,0,0,2.861,2.861h7.211V33.4H44.071a2.865,2.865,0,0,0-2.861,2.86Zm4.584,0A1.364,1.364,0,1,1,44.43,34.9,1.364,1.364,0,0,1,45.794,36.26Z",
    transform: "translate(-21.458 -19.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122210-3",
    "data-name": "Path 122210",
    d: "M41.21,36.26a2.865,2.865,0,0,0,2.861,2.861h7.211V33.4H44.071a2.865,2.865,0,0,0-2.861,2.86Zm4.584,0A1.364,1.364,0,1,1,44.43,34.9,1.364,1.364,0,0,1,45.794,36.26Z",
    transform: "translate(-21.46 -19.03)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122211-2",
    "data-name": "Path 122211",
    d: "M32.594,19.4H5.23A1.233,1.233,0,0,0,4,20.631V38.72a1.233,1.233,0,0,0,1.23,1.233H32.594a1.233,1.233,0,0,0,1.23-1.233V33.575H26.66a3.9,3.9,0,1,1,0-7.8h7.164V20.631A1.233,1.233,0,0,0,32.594,19.4Z",
    transform: "translate(-4 -12.415)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122211-3",
    "data-name": "Path 122211",
    d: "M32.594,19.4H5.23A1.233,1.233,0,0,0,4,20.631V38.72a1.233,1.233,0,0,0,1.23,1.233H32.594a1.233,1.233,0,0,0,1.23-1.233V33.575H26.66a3.9,3.9,0,1,1,0-7.8h7.164V20.631A1.233,1.233,0,0,0,32.594,19.4Z",
    transform: "translate(-4 -12.42)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122212-3",
    "data-name": "Path 122212",
    d: "M46.964,38.775a.292.292,0,1,0-.292-.292A.292.292,0,0,0,46.964,38.775Z",
    transform: "translate(-23.95 -21.25)",
    fill: "#dcf8c5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122212-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122212-4",
    "data-name": "Path 122212",
    d: "M46.964,38.775a.292.292,0,1,0-.292-.292A.292.292,0,0,0,46.964,38.775Z",
    transform: "translate(-23.95 -21.25)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122213-2",
    "data-name": "Path 122213",
    d: "M40.256,12.283,34.345,6.371l-3.4,3.4s0,.01-.009.013L28.49,12.23l-.054.054Z",
    transform: "translate(-15.477 -6.37)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122213-3",
    "data-name": "Path 122213",
    d: "M40.256,12.283,34.345,6.371l-3.4,3.4s0,.01-.009.013L28.49,12.23l-.054.054Z",
    transform: "translate(-15.48 -6.37)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122214-2",
    "data-name": "Path 122214",
    d: "M14.284,12.281h6.069L23.229,9.4,20.195,6.37Z",
    transform: "translate(-8.822 -6.37)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_122214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122214-3",
    "data-name": "Path 122214",
    d: "M14.284,12.281h6.069L23.229,9.4,20.195,6.37Z",
    transform: "translate(-8.82 -6.37)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet .c4b05ce2c1109e5a2de673f155a26f47.svg";
export { ForwardRef as ReactComponent };